import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, Params } from '@angular/router';

/** Route `data` flag: recreate the route's components when its params change. */
export const RECREATE_ON_PARAMS_CHANGE = 'recreateOnParamsChange';

/**
 * Angular reuses a route's component when only its params change (e.g.
 * /profile/a → /profile/b), so components that read `route.snapshot` once in
 * ngOnInit keep showing the previous record while the URL moves on. Routes
 * that opt in with `data: { recreateOnParamsChange: true }` are recreated
 * instead, together with their child routes, whenever their own params change.
 * Every other route keeps Angular's default reuse.
 */
@Injectable()
export class ParamAwareRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!super.shouldReuseRoute(future, curr)) return false;
    if (!future.routeConfig?.data?.[RECREATE_ON_PARAMS_CHANGE]) return true;
    return sameParams(future.params, curr.params);
  }
}

function sameParams(a: Params, b: Params): boolean {
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every((key) => a[key] === b[key]);
}
